import React from "react";
import { Field, WrappedFieldArrayProps } from "redux-form";
import InputWithLabel from "shared/components/redux-form/InputWithLabel";
import Select from "shared/components/redux-form/Select";
import clsx from "clsx";
import { maxLength } from "core/utils/Normalizer";
import { BEST_OF_OPTIONS } from "..";

interface RoundItem {
  roundName: string;
  roundSequence: number;
  matchFormat?: string;
}

interface BracketRoundsProps extends WrappedFieldArrayProps<RoundItem> {
  sectionKey: string;
}

const BracketRoundFields: React.FC<BracketRoundsProps> = ({ fields, sectionKey }) => {
  
    return (
      <>
        {fields.map((fieldName, index) => (
          <div key={index}>
            <div className="section-sec-title spacing">Round {index + 1}</div>
            <div className={clsx("bracket-grid-form-wrapper", "spacing")}>
              <div className="input-container">
                <Field
                  name={`${fieldName}.roundName`}
                  component={InputWithLabel}
                  placeholder="Enter Round Name"
                  label={`Round ${index + 1}`}
                  normalize={(value: string) => maxLength(value, 50)}
                />
              </div>
              <div className="input-container">
                <Field
                  name={`${fieldName}.matchFormat`}
                  component={Select}
                  placeholder="Select Best of it"
                  label="Match Format"
                  options={BEST_OF_OPTIONS}
                />
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };
  
  

export default BracketRoundFields;
